/** 验证码输入、获取 */
import React, { FC, useState, useEffect } from 'react'
import { IonInput } from '@ionic/react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { toast } from '@utils'
import { memberMobx } from '@mobxStore'
import MemberApi from '@api/member.api'
import './index.scss'

interface IProps {
  autoSend?: boolean;
  countryCode?: string;
  maxlength?: number;
  codeType: string;
  account: string;
  accountType: string;
  onChange?: ({ inputValue, valid }: { inputValue: any; valid?: any }) => any;
}
interface IState {
  code: string;
  seconds: number;
}

const verifyCodeRegister = memberMobx.verifyCodeTypes.register

const VerifyCodeInput: FC<IProps> = (props) => {
  const {
    autoSend,
    codeType,
    account,
    accountType,
    countryCode,
    onChange,
    maxlength
  } = props
  const initialState: IState = {
    code: '',
    seconds: 0
  }
  let loading = false
  const [code, setCode] = useState(initialState.code)
  const [seconds, setSeconds] = useState(initialState.seconds)
  const [firstGet, setFirstGet] = useState<boolean>(false)
  // send code
  const handleSendCode = async () => {
    if (!account) {
      toast({ message: i18n.t('common.numberTips') })
      return
    }
    if (seconds > 0 || loading) {
      return
    }
    const params: any = {
      type: codeType,
    }
    if (accountType === 'email') {
      params.email = account
    } else if (accountType === 'mobile') {
      params.mobile = account
      params.countryCode = Number(countryCode)
    }
    if (codeType === verifyCodeRegister) {
      try {
        loading = true
        const res = window.bo === 'cn' ? await MemberApi.chcekEshineCoin() : { valid: true }
        if (!res?.valid) {
          toast({
            message: `${i18n.t('mkt.member.unableRegisterTip1')}<br/>${i18n.t('mkt.member.unableRegisterTip3')}`,
            time: 2000,
            position: 'middle',
            cssClass: 'toastW80'
          })
          return
        }
      } catch (error) {
        console.error(error)
        return
      } finally {
        loading = false
      }
    }
    setFirstGet(false)
    loading = true
    memberMobx.sendCode(params).then((success: any) => {
      if (success) {
        setSeconds(60)
        toast({ message: i18n.t('mkt.member.sendSuccess') })
      }
      loading = false
    }).catch(() => {
      loading = false
    })
  }
  // code change
  const handleChange = (val: any) => {
    setCode(val)
    onChange && onChange({
      inputValue: val,
      valid: !!val
    })
  }
  // useEffect
  useEffect(() => {
    setCode(initialState.code)
    setSeconds(initialState.seconds)
    if (autoSend) {
      handleSendCode()
    } else {
      setFirstGet(true)
    }
  }, [autoSend, accountType])
  useEffect(() => {
    let timerId = null as any
    timerId = setTimeout(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }
    }, 1000)
    return () => {
      timerId && clearTimeout(timerId)
    }
  }, [seconds])
  return (
    <div className='mkt-verify-input'>
      <IonInput type='text' maxlength={maxlength || 4} value={code} placeholder={i18n.t('mkt.common.tipCode')} data-cypid='mktVerifyInput' onIonChange={e => handleChange(e.detail.value)} clearInput></IonInput>
      {seconds > 0 ? <span className='time-span'>{seconds + 'S'}</span>
        : <div className='btn-send' data-cypid='mktVerifyInputSendCode' onClick={() => handleSendCode()}> <span>{firstGet ? i18n.t('mkt.common.gitVerCode') : i18n.t('mkt.common.sendAgain')}</span></div>}
    </div>
  )
}

export default observer(VerifyCodeInput)
